import React from 'react';
import cx from 'classnames';

interface IGQDropDownProps {
    dropDownContent: JSX.Element[];
    selectedItem: any;
    showSearchItem: boolean;
    useAutoHeight: boolean;
}
interface IGQDropDownState {
    openDropDown: boolean;
    searchFilter: string;
}

class ExternalDataDropDownSearch extends React.Component<IGQDropDownProps, IGQDropDownState> {
    constructor(props: IGQDropDownProps) {
        super(props);
        this.state = {
            openDropDown: true,
            searchFilter: '',
        };
    }

    public render() {
        const { showSearchItem, useAutoHeight } = this.props;
        return (
            <div className="drop-down-container">
                {showSearchItem && (
                    <div className="drop-down-selected-item">
                        <i className="gqi-search" style={{ marginLeft: 8 }} />
                        <div className="selected-item-name">
                            {this.renderExpandedSelectBox()}
                        </div>
                    </div>
                )}
                {this.state.openDropDown && (
                    <div className={cx("drop-down-list-element", { "resize-box-height": useAutoHeight })}>
                        {' '}
                        {this.renderFilteredDropdownList()}{' '}
                    </div>
                )}
            </div>
        );
    }

    private renderFilteredDropdownList = () => {
        const regex = new RegExp(this.state.searchFilter, 'i');
        if (this.state.searchFilter && this.state.searchFilter.length > 0) {
            return this.props.dropDownContent.filter(elem =>
                regex.test(elem.props['data-searchable-text'])
            );
        } else {
            return this.props.dropDownContent;
        }
    };

    private renderExpandedSelectBox = () => {
        if (this.state.openDropDown) {
            return (
                <input
                    className="select-from-list custom-dropdown-search"
                    type="text"
                    placeholder="Search"
                    value={this.state.searchFilter}
                    onChange={this.onDropdownSearch}
                    autoFocus
                />
            );
        } else {
            return this.props.selectedItem;
        }
    };

    private onDropdownSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { currentTarget } = e;
        this.setState({
            searchFilter: currentTarget.value,
        });
    };
}

export default ExternalDataDropDownSearch;
